import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';
import { customStorage } from '../foo'; // Adjust import path as necessary

interface CacheItem {
  data: string[];
  timestamp: number;
}

interface CacheState {
  retrievalCache: { [query: string]: { [source: string]: CacheItem } };
  updateRetrievalCache: (query: string, source: string, images: string[]) => void;
}

export const useCacheStore = create<CacheState>()(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        retrievalCache: {},

        updateRetrievalCache: (query: string, source: string, images: string[]) => {
          set((state) => {
            const updatedCache = { ...state.retrievalCache };

            // Insert or update the source for the given query
            if (!updatedCache[query]) updatedCache[query] = {};
            updatedCache[query][source] = { data: images, timestamp: Date.now() };

            // Keep only the latest 10 queries in the cache
            const queries = Object.keys(updatedCache).sort((a, b) => updatedCache[b][source]?.timestamp - updatedCache[a][source]?.timestamp);
            if (queries.length > 10) {
              const oldestQuery = queries.slice(10);
              oldestQuery.forEach(query => {
                delete updatedCache[query];
              });
            }

            return { retrievalCache: updatedCache };
          });
        },
      }),
      {
        name: "cacheState",
        storage: customStorage,
        partialize: (state) => ({ retrievalCache: state.retrievalCache }),
      }
    )
  )
);
